import {NativeDateAdapter} from '@angular/material/core';
import {Platform} from '@angular/cdk/platform';
import {Injectable} from '@angular/core';


export function isTimestamp(value: any): boolean {
    return value && value.hasOwnProperty('seconds') && value.hasOwnProperty('nanoseconds');
}

@Injectable()
export class TimestampDateAdapter extends NativeDateAdapter {

    constructor(matDateLocale: string) {
        super(matDateLocale);
    }

    deserialize(value: any): Date | null {
        if (isTimestamp(value)) {
            return super.deserialize(new Date(value.seconds * 1000));
        }
        return super.deserialize(value);
    }
}
